import { FormattedMessage } from 'react-intl';

const page = 'pdfErrorPage';
export function PdfErrorPage() {
  return (
    <div className="view-error-page">
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered medium image custom-image" src="/unlink.png" alt="unlink" />
        </div>
      </div>
      <div className="custom-header mark">
        <FormattedMessage
          id={`${page}.pdfLinkExpired`}
          defaultMessage="Unfortunately, The PDF Download link is expired"
        />
      </div>
      <div className="description">
        <p>
          <FormattedMessage
            id={`${page}.newLinkInfo`}
            defaultMessage="Another email containing the PDF link will be sent to you shortly."
          />
        </p>
      </div>
    </div>
  );
}
